import { useMemo, useCallback } from 'react';
import * as THREE from 'three';


function D({color, vertices}) {
  
  const vPoints = useMemo(() => [new THREE.Vector3(...vertices.upperLeft), new THREE.Vector3(...vertices.bottom), new THREE.Vector3(...vertices.upperRight),new THREE.Vector3(...vertices.upperLeft)], [])
  const onUpdate = useCallback(self => self.setFromPoints(vPoints), [vPoints])

  return (
    <line>
        <bufferGeometry attach="geometry" onUpdate={onUpdate} />
        <lineBasicMaterial attach="material" color={color} linecap={'round'} linejoin={'round'} />
      </line>
);
};

export default D